import CloseIcon from "@mui/icons-material/Close";
import { TableContainer } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import React, { useState } from "react";
import axiosInstance from "../../Axios";
import useAuth from "../../contexts/UserContext.tsx";
import { toast } from "sonner";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: 3,
  border: 0,
  boxShadow: 24,
  height: "90vh",
  width: "90vw",
  p: 4,
};

export const StudentExeProgressCards = ({ data, id }) => {
  const { user } = useAuth();
  const [chapter, setChapter] = useState({});
  const [item, setItem] = useState();

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = (id) => {
    setChapter(data.filter((item) => item.sec_id === id));
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setChapter({});
    setOpenModal(false);
  };

  const [openItemModal, setOpenItemModal] = useState(false);
  const handleOpenItemModal = () => {
    setOpenItemModal(true);
  };
  const handleCloseItemModal = () => setOpenItemModal(false);

  const [studentExerciseStatus, setStudentExerciseStatus] = useState();

  const getStudentStatusExercise = async (item_id) => {
    try {
      setItem(chapter[0].items.filter((item) => item.item_id === item_id));
      const res = await axiosInstance.post("/getStudentStatusExercise", {
        auth_token: user.auth_token,
        school_id: id,
        excs_id: item_id,
      });
      setStudentExerciseStatus(res.data.data.crs_details[0]);
      handleOpenItemModal();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const columns = [
    {
      field: "item_title",
      headerName: "Chapter Name",
      width: 200,
      flex: 3,
      renderHeader: () => {
        return <div className="font-bold">Chapter Name</div>;
      },
      renderCell: (params) => {
        return (
          <p onClick={() => getStudentStatusExercise(params.id)}>
            <span className="text-[#8A89DB] hover:underline hover:cursor-pointer">
              {params.row.item_title}
            </span>
          </p>
        );
      },
    },
    {
      field: "NotStarted",
      headerName: "Not Started",
      width: 130,
      flex: 1,
      sortComparator: (a, b) => {
        return a - b;
      },
      renderHeader: () => {
        return <div className="font-bold text-[#eab80f]">Not Started</div>;
      },
      renderCell: (params) => {
        return (
          <div>
            {`${params.row.NotStarted} `}
            <span className="font-medium text-sm text-[#eab80f]">
              ({Math.round(params.row.NotStarted_Percentage)}%)
            </span>
          </div>
        );
      },
    },
    {
      field: "Started",
      headerName: "Started",
      width: 130,
      flex: 1,
      sortComparator: (a, b) => {
        return a - b;
      },
      renderHeader: () => {
        return <div className="font-bold text-[rgb(15,158,234)]">Started</div>;
      },
      renderCell: (params) => {
        return (
          <div>
            {`${params.row.Started} `}
            <span className="font-medium text-sm text-[rgb(15,158,234)]">
              ({Math.round(params.row.Started_Percentage)}%)
            </span>
          </div>
        );
      },
    },
    {
      field: "Struggling",
      headerName: "Struggling",
      width: 130,
      flex: 1,
      sortComparator: (a, b) => {
        return a - b;
      },
      renderHeader: () => {
        return <div className="font-bold text-[#ea271a]">Struggling</div>;
      },
      renderCell: (params) => {
        return (
          <div>
            {`${params.row.Struggling} `}
            <span className="font-medium text-sm text-[#ea271a]">
              ({Math.round(params.row.Struggling_Percentage)}%)
            </span>
          </div>
        );
      },
    },
    {
      field: "Completed",
      headerName: "Completed",
      width: 130,
      flex: 1,
      sortComparator: (a, b) => {
        return a - b;
      },
      renderHeader: () => {
        return <div className="font-bold text-[#1b9808]">Completed</div>;
      },
      renderCell: (params) => {
        return (
          <div>
            {`${params.row.Completed} `}
            <span className="font-medium text-sm text-[#1b9808]">
              ({Math.round(params.row.Completed_Percentage)}%)
            </span>
          </div>
        );
      },
    },
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{ padding: 2, display: "flex", justifyContent: "space-between" }}
      >
        {chapter && (
          <div className="tableTitle text-md">{chapter[0]?.sec_name}</div>
        )}
        <div className="flex">
          <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
        </div>
      </GridToolbarContainer>
    );
  }

  return (
    <div className="grid grid-cols-4 gap-4 mt-2">
      {data.map((item) => (
        <Card sx={{ minWidth: 220 }} key={item.sec_id}>
          <CardContent
            sx={{ cursor: "pointer" }}
            onClick={() => handleOpenModal(item.sec_id)}
          >
            {item.sec_name}
          </CardContent>
        </Card>
      ))}
      <Modal
        open={openModal}
        // onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, overflowY: "scroll" }}>
          <div className="flex justify-end">
            <button onClick={handleCloseModal}>
              <CloseIcon />
            </button>
          </div>

          <div className="student-progress-data-table-container mt-4">
            <TableContainer className="tableContainer shadow-md m-1">
              {chapter[0]?.items && (
                <DataGrid
                  rowHeight={50}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                  pagination
                  disablePageSize
                  disableSelectionOnClick
                  columns={columns}
                  autoHeight={true}
                  rows={chapter[0]?.items.map((prev) => {
                    return {
                      ...prev,
                      Completed: parseInt(prev.Completed),
                      Started: parseInt(prev.Started),
                      Struggling: parseInt(prev.Struggling),
                    };
                  })}
                  getRowId={(row) => row.item_id}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                  componentsProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: { debounceMs: 500 },
                    },
                  }}
                />
              )}
            </TableContainer>
          </div>
        </Box>
      </Modal>

      {/* Item Modal */}

      <Modal
        open={openItemModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, overflowY: "scroll" }}>
          <div className="flex justify-between">
            <div>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                List of Students and Exercise status
              </Typography>

              <Typography variant="h6" component="h2">
                {item && item[0]?.item_title}
              </Typography>
            </div>
            <div>
              <button onClick={handleCloseItemModal}>
                <CloseIcon />
              </button>
            </div>
          </div>
          <div className="mt-5 grid grid-cols-4 gap-3">
            <div className="not-started-container">
              <div className="flex items-center justify-center text-white bg-[#eab80f] p-2 rounded-md">
                <p className="text-white text-lg font-bold">Not Started</p>
              </div>
              {studentExerciseStatus &&
                (studentExerciseStatus.NOTSTARTED[0] === "" ? (
                  <div className="flex items-center p-2 justify-center rounded-md gap-2 mt-2">
                    <p className="text-sm">No Students</p>
                  </div>
                ) : (
                  <>
                    {studentExerciseStatus.NOTSTARTED.map((item) => (
                      <div className="flex items-center p-2 justify-center bg-slate-200 rounded-md gap-2 mt-2">
                        <p className="text-sm">{item}</p>
                      </div>
                    ))}
                  </>
                ))}
            </div>

            <div className="started-container">
              <div className="flex items-center justify-center text-white bg-[rgb(15,158,234)] p-2 rounded-md">
                <p className="text-white text-lg font-bold">Started</p>
              </div>
              {studentExerciseStatus &&
                (studentExerciseStatus.STARTED[0] === "" ? (
                  <div className="flex items-center p-2 justify-center rounded-md gap-2 mt-2">
                    <p className="text-sm">No Students</p>
                  </div>
                ) : (
                  <>
                    {studentExerciseStatus.STARTED.map((item) => (
                      <div className="flex items-center p-2 justify-center bg-slate-200 rounded-md gap-2 mt-2">
                        <p className="text-sm">{item}</p>
                      </div>
                    ))}
                  </>
                ))}
            </div>

            <div className="struggling-container">
              <div className="flex items-center justify-center text-white bg-[#ea271a] p-2 rounded-md">
                <p className="text-white text-lg font-bold">Struggling</p>
              </div>
              {studentExerciseStatus &&
                (studentExerciseStatus.STRUGGLING[0] === "" ? (
                  <div className="flex items-center p-2 justify-center rounded-md gap-2 mt-2">
                    <p className="text-sm">No Students</p>
                  </div>
                ) : (
                  <>
                    {studentExerciseStatus.STRUGGLING.map((item) => (
                      <div className="flex items-center p-2 justify-center bg-slate-200 rounded-md gap-2 mt-2">
                        <p className="text-sm">{item}</p>
                      </div>
                    ))}
                  </>
                ))}
            </div>

            <div className="completed-container">
              <div className="flex items-center justify-center text-white bg-[#1b9808] p-2 rounded-md">
                <p className="text-white text-lg font-bold">Completed</p>
              </div>
              {studentExerciseStatus &&
                (studentExerciseStatus.Completed[0] === "" ? (
                  <div className="flex items-center p-2 justify-center rounded-md gap-2 mt-2">
                    <p className="text-sm">No Students</p>
                  </div>
                ) : (
                  <>
                    {studentExerciseStatus.Completed.map((item) => (
                      <div className="flex items-center p-2 justify-center bg-slate-200 rounded-md gap-2 mt-2">
                        <p className="text-sm">{item}</p>
                      </div>
                    ))}
                  </>
                ))}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
